import { NgModule } from '@angular/core';

import { PegaRetailModule } from '@ap/pega';

import { SamenRekeningOpenenModule } from '../samen-rekening-openen/samen-rekening-openen.module';

import { RetailSamenRekeningOpenenComponent } from './retail-samen-rekening-openen.component';

@NgModule({
    imports: [PegaRetailModule, SamenRekeningOpenenModule],
    exports: [RetailSamenRekeningOpenenComponent],
    declarations: [RetailSamenRekeningOpenenComponent],
    bootstrap: [RetailSamenRekeningOpenenComponent]
})
export class RetailSamenRekeningOpenenModule {}
